export default __webpack_public_path__ + "static/media/person.37a62741.jpg";